import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=064181ec"
import script from "./TablePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./TablePagination.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports